export default {
  name: 'gmk-serika',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_PENT: 'accent'
  }
};
